import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "worlds" }
const _hoisted_2 = { class: "worlds__top" }
const _hoisted_3 = { class: "worlds__slider" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "worlds__item-wrap" }
const _hoisted_7 = { class: "worlds__bottom" }
const _hoisted_8 = { class: "worlds-modal__wrap" }
const _hoisted_9 = { class: "worlds-modal__video" }
const _hoisted_10 = ["src"]

import DecorTitle from "@/components/uikit/DecorTitle.vue";
import UserPoints from "@/components/uikit/UserPoints.vue";
import GreenButton from "@/components/uikit/GreenButton.vue";
import { useRouter } from "vue-router";
import { useGameStore } from "@/stores/index";
import { ref, computed, onMounted, watch } from "vue";
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/grid";
import "swiper/css/pagination";
import "swiper/css/effect-fade";
import { Grid, Pagination, Navigation } from "swiper/modules";
import { getImagePath } from "@/utils/image";

interface World {
  id: number;
  name: string;
}

const maxSelection = 1;

export default /*@__PURE__*/_defineComponent({
  __name: 'WorldsScreen',
  setup(__props) {

const modules = [Grid, Pagination, Navigation];
const store = useGameStore();
const router = useRouter();
const selectedItems = ref<World[]>([]);
const videoUrl = ref("");
const worldsModal = ref(false);

const pagination = {
  el: ".worlds-pagination",
  clickable: true,
};
const navigation = {
  nextEl: ".worlds .slider-navigation__btn--next",
  prevEl: ".worlds .slider-navigation__btn--prev",
};

// Переключение активности
const toggleSelection = (item: World) => {
  const index = selectedItems.value.findIndex(
    (selected) => selected.id === item.id
  );

  if (index !== -1) {
    selectedItems.value.splice(index, 1);
  } else if (selectedItems.value.length < maxSelection) {
    selectedItems.value.push(item);
  }
};

// Выбор мира
const selectWorlds = async () => {
  if (selectedItems.value.length === 1) {
    const ids = selectedItems.value.map((item) => Number(item.id));

    await store.selectWorlds(ids[0]);
    router.push("/mission");
  }
};

const selectVideo = (video: string) => {
  videoUrl.value = video;
  worldsModal.value = true;
};

const closeModal = () => {
  videoUrl.value = "";
  worldsModal.value = false;
};

watch(
  () => store.playerInfoArray?.selectedWorlds,
  (newValue) => {
    if (newValue) {
      selectedItems.value = newValue;
    }
  },
  { immediate: true }
);

onMounted(() => {
  store.getWorlds();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "worlds__bg" }, [
        _createElementVNode("img", {
          src: "/images/worlds-bg.jpg",
          alt: ""
        })
      ], -1)),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(DecorTitle, {
          title: 'Выбери мир для путешествий',
          icon: '/images/worlds-icon-top.svg'
        }),
        _createVNode(UserPoints, {
          count1: _unref(store).playerScore
        }, null, 8, ["count1"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_unref(Swiper), {
          slidesPerView: 3,
          grid: {
          rows: 4,
          fill: 'row',
        },
          spaceBetween: 30,
          slidesPerGroup: 3,
          modules: modules,
          pagination: pagination,
          navigation: navigation
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).worldsList, (item, i) => {
              return (_openBlock(), _createBlock(_unref(SwiperSlide), { key: i }, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    class: "worlds__item-icon",
                    onClick: ($event: any) => (selectVideo(item.videoUrl))
                  }, null, 8, _hoisted_4),
                  _createElementVNode("div", {
                    class: _normalizeClass(["worlds__item", {
              'worlds__item--active': selectedItems.value.some(
                (selected) => selected.id === item.id
              ),
            }]),
                    onClick: ($event: any) => (toggleSelection(item))
                  }, [
                    _createElementVNode("div", _hoisted_6, _toDisplayString(item.name), 1)
                  ], 10, _hoisted_5)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }),
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "slider-navigation" }, [
          _createElementVNode("div", { class: "slider-navigation__btn slider-navigation__btn--prev" }),
          _createElementVNode("div", { class: "slider-navigation__btn slider-navigation__btn--next" })
        ], -1)),
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "slider-pagination worlds-pagination" }, null, -1))
      ]),
      _createElementVNode("div", _hoisted_7, [
        (selectedItems.value.length === 1)
          ? (_openBlock(), _createBlock(GreenButton, {
              key: 0,
              onClick: selectWorlds
            }, {
              default: _withCtx(() => _cache[2] || (_cache[2] = [
                _createTextVNode("Далее")
              ])),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["worlds-modal", { 'worlds-modal--active': worldsModal.value }])
    }, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", {
          class: "worlds-modal__back",
          onClick: closeModal
        }, "Вернуться"),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("video", {
            src: _unref(getImagePath)(videoUrl.value),
            controls: ""
          }, null, 8, _hoisted_10)
        ])
      ])
    ], 2)
  ], 64))
}
}

})